import { z } from "zod";

export const serviceCategorySchema = z.enum([
  "pipette_calibration",
  "balance_calibration",
]);
export type ServiceCategory = z.infer<typeof serviceCategorySchema>;

export const accreditationRequirementSchema = z.enum(["no", "unknown", "yes"]);
export type AccreditationRequirement = z.infer<
  typeof accreditationRequirementSchema
>;

export const derivedServiceFitSchema = z.enum([
  "unknown",
  "qualified",
  "disqualified",
]);
export type DerivedServiceFit = z.infer<typeof derivedServiceFitSchema>;

export const queueCodeSchema = z.enum([
  "NOW",
  "COMING",
  "INVESTIGATE",
  "SLEEPING",
  "DISQUALIFIED_SERVICE_NEED",
]);
export type QueueCode = z.infer<typeof queueCodeSchema>;

export const serviceCategoryLabels: Record<ServiceCategory, string> = {
  pipette_calibration: "Pipettes",
  balance_calibration: "Balances",
};

export const accreditationRequirementLabels: Record<
  AccreditationRequirement,
  string
> = {
  no: "No",
  unknown: "Unknown",
  yes: "Yes",
};

export const derivedServiceFitLabels: Record<DerivedServiceFit, string> = {
  unknown: "Unknown",
  qualified: "Qualified",
  disqualified: "Disqualified",
};

export const queueCodeLabels: Record<QueueCode, string> = {
  NOW: "Now",
  COMING: "Coming",
  INVESTIGATE: "Investigate",
  SLEEPING: "Sleeping",
  DISQUALIFIED_SERVICE_NEED: "Disqualified service need",
};
